import React from 'react';
import { useGetConversationThreadQuery } from 'store/services/message/messageApi';
import { isCaseContext, isOfferContext, isTradeContext } from 'types/interfaces/thread';
import { formatCaseNumber } from 'utils/caseNumber';
import { STATUS_TONE_CLASS, THREAD_TYPE_STYLES } from '../threadTypeStyles';
import { statusChipFor } from '../threadStatus';

interface Props {
  conversationId: string;
  onOpenDetails: () => void;
}

/**
 * Mobile screen 2 (Decision 13): the single 48px strip under the thread
 * header, "{Type} {id}" plus the status chip plus "Details ›", which opens the
 * context sheet. Direct and system threads have nothing to show and render no
 * strip.
 */
export const MobileContextStrip: React.FC<Props> = ({ conversationId, onOpenDetails }) => {
  // currentData so a thread that fails to load shows no strip from the previous one.
  const { currentData: thread } = useGetConversationThreadQuery(conversationId);
  const context = thread?.context;
  if (!thread || !context) return null;

  let label: string;
  let color: string;
  if (isTradeContext(context)) {
    label = `Trade ${context.tradeNumber}`;
    color = THREAD_TYPE_STYLES.TRADE.color;
  } else if (isCaseContext(context)) {
    label = `Case ${formatCaseNumber(context.caseNumber) ?? ''}`.trim();
    color = THREAD_TYPE_STYLES.CASE.color;
  } else if (isOfferContext(context)) {
    label = 'Trade offer';
    color = THREAD_TYPE_STYLES.OFFER.color;
  } else {
    return null;
  }

  const chip = statusChipFor(context);

  return (
    <button type="button" className="mobile-context-strip" onClick={onOpenDetails} aria-label={`${label} details`}>
      <span className="mobile-context-strip-label" style={{ color }}>{label}</span>
      {chip && <span className={`status-badge rail-status ${STATUS_TONE_CLASS[chip.tone]}`}>{chip.label}</span>}
      <span className="mobile-context-strip-cta">Details ›</span>
    </button>
  );
};

export default MobileContextStrip;
